module.exports = __webpack_public_path__ + "static/media/rome-19.36232710.jpg";